import classNames from 'classnames';
import type { IAsset } from '../../../../../common/validation/assets';
import { Icon, IconColor } from '../../atoms/icon/Icon';

interface IAssetThumbnailProps {
    file?: IAsset;
    onlyThumbnails?: boolean;
    onThumbnailRemove?: () => void;
    showFilenames?: boolean;
    smallThumbnails?: boolean;
}

export function AssetThumbnail(props: IAssetThumbnailProps) {
    function Image() {
        return !props.file ? (
            <img
                alt="Asset thumbnail"
                data-dz-thumbnail
            />
        ) : (
            <img
                alt="Asset thumbnail"
                src={props.file.thumbnailDataUrl}
            />
        );
    }

    function Thumbnail() {
        let baseClassName = 'dz-preview dz-file-preview';
        if (props.file) {
            baseClassName += ' dz-image-preview dz-success';
        }

        return (
            <div className={baseClassName}>
                <div
                    className={classNames(
                        'dz-details',
                        props.smallThumbnails ? 'small-thumbnail' : '',
                        !props.file?.thumbnailDataUrl ? 'placeholder' : ''
                    )}
                >
                    <Image />
                </div>
                {props.showFilenames && props.file && (
                    <div className="dz-filename">
                        <span>{props.file?.filename}</span>
                        {props.file?.filename && (
                            <Icon
                                color={IconColor.primary}
                                icon="check"
                                size="small"
                            />
                        )}
                    </div>
                )}
                {!props.onlyThumbnails && (
                    <div className="dz-success-mark">
                        <button
                            data-dz-remove
                            onClick={() => props.onThumbnailRemove && props.onThumbnailRemove()}
                        >
                            <Icon
                                color={IconColor.primary}
                                icon="delete"
                                size="small"
                            />
                        </button>
                    </div>
                )}
                {!props.file && (
                    <>
                        <div className="dz-progress">
                            <span
                                className="dz-upload"
                                data-dz-uploadprogress
                            ></span>
                        </div>
                        <div className="dz-error-mark">
                            <Icon
                                color={IconColor.danger}
                                icon="info"
                                size="small"
                            />
                        </div>
                        <div className="dz-error-message">
                            <span data-dz-errormessage></span>
                        </div>
                    </>
                )}
            </div>
        );
    }

    if (props.file) {
        return (
            <div className="filepicker dropzone asset-dropzone dz-started">
                <Thumbnail />
            </div>
        );
    } else {
        return <Thumbnail />;
    }
}
